import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const customFavicon = process.env.REACT_APP_FAVICON?.trim();
if (customFavicon) {
  const faviconLink = document.querySelector("link[rel='icon']");
  if (faviconLink) {
    faviconLink.href = customFavicon;
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
